import {Application} from '../../../../documents';
import {AccountStatus, CardBrand} from '../../../../shared';

export type BatchDetail = {
  cardBrand: string;
  salesAmount: number;
  transactionsCount: number;
};

export type BatchFlattenDetails = {
  visaSalesAmount: number;
  visaTransactionsCount: number;
  mastercardSalesAmount: number;
  mastercardTransactionsCount: number;
  amexSalesAmount: number;
  amexTransactionsCount: number;
  discoverSalesAmount: number;
  discoverTransactionsCount: number;
  ebtSalesAmount: number;
  ebtTransactionsCount: number;
  pinSalesAmount: number;
  pinTransactionsCount: number;
};

export type Batch = {
  id: number;
  merchantBankAccount: string;
  batchDate: string;
  statementDate: string;
  merchantReferenceNumber: string;
  rejectReason: string;
  netDeposit: number;
  creditsAmount: number;
  rejectsAmount: number;
  transactionsCount: number;
  batchedAmount: number;
  approvedBatches: number;
  hasDuplicateRejectsWithin30Days?: boolean;
  details: BatchDetail[];
  flattenDetails: BatchFlattenDetails;
};

export type MinMaxBatchInfo = {
  id: string;
  mid: string;
  dbaName: string;
  createdAt: Date;
  firstName: string;
  lastName: string;
  customerServiceEmail: string;
  businessAddress1: string | null;
  businessAddress2: string | null;
  businessCity: string | null;
  businessState: string | null;
  businessZip: string | null;
  businessPhone: string | null;
  agentName: string;
  groupName: string;
  accountStatus: Application['accountStatus'] | null;
  riskStatus: Application['riskStatus'] | null;
  riskLabels: Application['riskLabels'] | null;
  riskAssigneeUid: Application['riskAssigneeUid'] | null;
  platform: Application['platform'];
  associatedApplications: Application['associatedApplications'];
  firstBatchDate: Date;
  lastBatchDate: Date;
  firstBatchAmount: number;
  lastBatchAmount: number;
};

export type MinMaxBatchResult = {
  id: string;
  mid: string;
  dbaName: string;
  firstName: string;
  lastName: string;
  customerServiceEmail: string;
  businessAddress1: string | null;
  businessAddress2: string | null;
  businessCity: string | null;
  businessState: string | null;
  businessZip: string | null;
  businessPhone: string | null;
  agentFirstName: string;
  agentLastName: string;
  groupName: string;
  createdAt: Date;
  accountStatus: string | null;
  riskStatus: Application['riskStatus'] | null;
  riskLabels: string | null;
  riskAssigneeUid: string | null;
  platform: Application['platform'];
  associatedApplications: string | null;
  firstBatchDate: Date;
  lastBatchDate: Date;
  firstBatchAmount: number;
  lastBatchAmount: number;
  rowsCount: number;
};

export type BatchMonitoringRecord = {
  mid: string;
  doingBusinessAs: string | null;
  legalBusinessName: string | null;
  agentName: string | null;
  accountStatus: AccountStatus | string | null;
  batchCount: number;
  batchAmount: number;
  dateBoarded: string | null;
  firstBatchDate: string | null;
  recentBatchDate: string | null;
  lastBatchDate: string | null;
  numberOfDaysSinceLastBatch: number | null;
  applicationId: string | null;
};

export type BatchMonitoringReport = BatchMonitoringRecord[];

export const batchCardBrandMap: Record<string, {property: string; label: string}> = {
  [CardBrand.visa]: {
    property: 'visa',
    label: 'Visa',
  },
  [CardBrand.mastercard]: {
    property: 'mastercard',
    label: 'MasterCard',
  },
  [CardBrand.amex]: {
    property: 'amex',
    label: 'American Express',
  },
  [CardBrand.discover]: {
    property: 'discovery',
    label: 'Discovery',
  },
  DB: {
    property: 'pin',
    label: 'Pin Debit',
  },
  K: {
    property: 'ebt',
    label: 'EBT',
  },
};
